"use strict"

import React, { useCallback } from "react"
import { Button } from "react-bootstrap"

import { isLTPM } from "../../../components/shared_components_registration"
import { withGraphState } from "../../config/GraphConfigProvider"

const default_graph_config_button = {
  button_title: (intl, curated_by) =>
    isLTPM
      ? intl.formatMessage(
          {
            id: "favourites.default.graph.configuration.curated.by",
            description: "Returns a message with the user who curated the default graph configuration.",
            defaultMessage: `Default graph configuration curated by '${curated_by}'.\nApplying a Favourite will override this configuration.\nClick here to restore default configuration.`,
          },
          { name: curated_by },
        )
      : `Default graph configuration curated by '${curated_by}'.\nApplying a Favourite will override this configuration.\nClick here to restore default configuration.`,
}

function DefaultGraphConfigButton({
  restoreDefaultGraphs,
  plots_curated_by,
  intl,
  button,
  type,
  extra_logic = () => {},
}) {
  const restoreGraphConfig = useCallback(() => {
    extra_logic()
    restoreDefaultGraphs(type)
  }, [extra_logic, type])

  return button ? (
    <Button
      variant={"outline-primary"}
      className={"btn btn-sm"}
      onClick={restoreGraphConfig}
      title={default_graph_config_button.button_title(intl, plots_curated_by)}
    >
      <span className="fa fa-certificate" />
    </Button>
  ) : (
    <span
      className={"fa fa-certificate fa-lg"}
      onClick={restoreGraphConfig}
      style={{ cursor: "pointer" }}
      title={default_graph_config_button.button_title(intl, plots_curated_by)}
    />
  )
}

export default withGraphState(DefaultGraphConfigButton)
